module.exports = __webpack_public_path__ + "img/close-folder.ac1a1bdc.svg";